import React from 'react';
import { propTypes } from './props';
import { OverlayBlocker, ToolBarWrapper } from './styled';
import { TemplateToolBar } from '../TemplateToolBar';
import { TextToolBar } from '../TextToolBar';
import { elementTypes, sideBarpillsList } from '@/constants';
import { ImageToolBar } from '../ImageToolBar';
import { ShapeToolBar } from '../ShapeToolBar';
import { QrToolBar } from '../QrToolBar';
import { isElementOfSameType } from '@/utils';

export const TopToolBar = ({
    selectedTab,
    onSetBackgroundColor,
    canvasBackgroundColor,
    canvasBackgroundImage,
    onSetBackgroundImage,
    shapeStrokeColor,
    shapeStrokeWidth,
    shapeFillColor,
    shapeOpacity,
    onChangeShapeStrokeColor,
    onChangeShapeStrokeWidth,
    onChangeShapeFill,
    onChangeShapeOpacity,
    selectedElement,
    onChangeBackgroundImageOpacity,
    backgroundImageOpacity,
    imageStrokeWidth,
    imageStrokeColor,
    imageOpacity,
    onChangeImageStrokeWidth,
    onChangeImageStrokeColor,
    onChangeImageOpacity,
    imageTintColor,
    imageTintStrength,
    onChangeImageTintColor,
    onChangeImageTintStrength,
    onClearImageTint,
    qrStrokeWidth,
    qrStrokeColor,
    qrOpacity,
    onChangeQrStrokeWidth,
    onChangeQrStrokeColor,
    onChangeQrOpacity,
    defaultTextProps,
    onChangeTextProperty,
    onSetPageSize,
    selectedPageSize,
    selectedPageSizeLabel,
    languageLocale,
    uploadImageCallBack,
    setLoadingUploadImage,
    cuttingGuideStroke,
    cuttingGuideStrokeColor,
    onChangeCuttingGuideProp,
    onRemoveBackgroundImage,
    showBackgroundImagePicker,
    showOpacityPicker,
    changeSelectedElementProperty,
}) => {
    return (
        <ToolBarWrapper disabled={selectedElement && !selectedElement?.draggable}>
            {selectedElement && !selectedElement?.draggable && (
                <OverlayBlocker
                    onClick={e => {
                        e?.stopPropagation();
                    }}
                />
            )}
            {selectedTab === sideBarpillsList?.template ? (
                <TemplateToolBar
                    onSetBackgroundColor={onSetBackgroundColor}
                    canvasBackgroundColor={canvasBackgroundColor}
                    canvasBackgroundImage={canvasBackgroundImage}
                    onSetBackgroundImage={onSetBackgroundImage}
                    onChangeBackgroundImageOpacity={onChangeBackgroundImageOpacity}
                    backgroundImageOpacity={backgroundImageOpacity}
                    onSetPageSize={onSetPageSize}
                    selectedPageSize={selectedPageSize}
                    selectedPageSizeLabel={selectedPageSizeLabel}
                    languageLocale={languageLocale}
                    uploadImageCallBack={uploadImageCallBack}
                    setLoadingUploadImage={setLoadingUploadImage}
                    cuttingGuideStroke={cuttingGuideStroke}
                    cuttingGuideStrokeColor={cuttingGuideStrokeColor}
                    onChangeCuttingGuideProp={onChangeCuttingGuideProp}
                    onRemoveBackgroundImage={onRemoveBackgroundImage}
                    showBackgroundImagePicker={showBackgroundImagePicker}
                    showOpacityPicker={showOpacityPicker}
                />
            ) : selectedTab === sideBarpillsList?.text ? (
                <TextToolBar
                    fontFamily={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.fontFamily
                            : defaultTextProps?.fontFamily
                    }
                    fontSize={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.fontSize
                            : defaultTextProps?.fontSize
                    }
                    lineHeight={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.lineHeight
                            : defaultTextProps?.lineHeight
                    }
                    color={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.color
                            : defaultTextProps?.color
                    }
                    textDecoration={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.textDecoration
                            : defaultTextProps?.textDecoration
                    }
                    fontStyle={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.fontStyle
                            : defaultTextProps?.fontStyle
                    }
                    fontWeight={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.fontWeight
                            : defaultTextProps?.fontWeight
                    }
                    textAlign={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.textAlign
                            : defaultTextProps?.textAlign
                    }
                    selectedElement={selectedElement}
                    textOpacity={
                        isElementOfSameType(selectedElement, elementTypes.text)
                            ? selectedElement?.opacity
                            : defaultTextProps?.opacity
                    }
                    onChangeTextProperty={onChangeTextProperty}
                    languageLocale={languageLocale}
                />
            ) : selectedTab === sideBarpillsList?.image ? (
                <ImageToolBar
                    imageStrokeWidth={imageStrokeWidth}
                    imageStrokeColor={imageStrokeColor}
                    imageOpacity={imageOpacity}
                    onChangeImageStrokeWidth={onChangeImageStrokeWidth}
                    onChangeImageStrokeColor={onChangeImageStrokeColor}
                    onChangeImageOpacity={onChangeImageOpacity}
                    imageTintColor={imageTintColor}
                    imageTintStrength={imageTintStrength}
                    onChangeImageTintColor={onChangeImageTintColor}
                    onChangeImageTintStrength={onChangeImageTintStrength}
                    onClearImageTint={onClearImageTint}
                    selectedElement={selectedElement}
                    languageLocale={languageLocale}
                />
            ) : selectedTab === sideBarpillsList?.shape ? (
                <ShapeToolBar
                    shapeStrokeColor={shapeStrokeColor}
                    shapeStrokeWidth={shapeStrokeWidth}
                    shapeFillColor={shapeFillColor}
                    onChangeShapeStrokeColor={onChangeShapeStrokeColor}
                    onChangeShapeStrokeWidth={onChangeShapeStrokeWidth}
                    onChangeShapeFill={onChangeShapeFill}
                    shapeOpacity={shapeOpacity}
                    onChangeShapeOpacity={onChangeShapeOpacity}
                    selectedElement={selectedElement}
                    languageLocale={languageLocale}
                    onChangeCornerRadius={val => {
                        changeSelectedElementProperty('cornerRadius', Number(val));
                    }}
                />
            ) : selectedTab === sideBarpillsList?.qr ? (
                <QrToolBar
                    qrStrokeWidth={qrStrokeWidth}
                    qrStrokeColor={qrStrokeColor}
                    qrOpacity={qrOpacity}
                    onChangeQrStrokeWidth={onChangeQrStrokeWidth}
                    onChangeQrStrokeColor={onChangeQrStrokeColor}
                    onChangeQrOpacity={onChangeQrOpacity}
                    selectedElement={selectedElement}
                    languageLocale={languageLocale}
                />
            ) : null}
        </ToolBarWrapper>
    );
};

TopToolBar.propTypes = propTypes;
